import { render, staticRenderFns } from "./EditBusinessOpportunity.vue?vue&type=template&id=c5cb7142&scoped=true"
import script from "./EditBusinessOpportunity.vue?vue&type=script&lang=js"
export * from "./EditBusinessOpportunity.vue?vue&type=script&lang=js"
import style0 from "./EditBusinessOpportunity.vue?vue&type=style&index=0&id=c5cb7142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5cb7142",
  null
  
)

export default component.exports